/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const submitManualAdjustment = /* GraphQL */ `mutation SubmitManualAdjustment(
  $material: String
  $size: String
  $countryOfOrigin: String
  $quality: String
  $location: String
  $type: Type
  $quantity: Int
  $customsStatus: CustomsStatus
  $reason: String
  $comment: String
  $clearGoodsIfNeeded: Boolean
) {
  submitManualAdjustment(
    material: $material
    size: $size
    countryOfOrigin: $countryOfOrigin
    quality: $quality
    location: $location
    type: $type
    quantity: $quantity
    customsStatus: $customsStatus
    reason: $reason
    comment: $comment
    clearGoodsIfNeeded: $clearGoodsIfNeeded
  ) {
    message
    success
    timestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitManualAdjustmentMutationVariables,
  APITypes.SubmitManualAdjustmentMutation
>;
export const submitManualDrsOrTransitAdjustment = /* GraphQL */ `mutation SubmitManualDrsOrTransitAdjustment(
  $material: String
  $size: String
  $countryOfOrigin: String
  $quality: String
  $location: String
  $type: Type
  $quantity: Int
  $customsStatus: CustomsStatus
  $reason: String
  $comment: String
  $container: String
  $bol: String
  $clearGoodsIfNeeded: Boolean
) {
  submitManualDrsOrTransitAdjustment(
    material: $material
    size: $size
    countryOfOrigin: $countryOfOrigin
    quality: $quality
    location: $location
    type: $type
    quantity: $quantity
    customsStatus: $customsStatus
    reason: $reason
    comment: $comment
    container: $container
    bol: $bol
    clearGoodsIfNeeded: $clearGoodsIfNeeded
  ) {
    message
    success
    timestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitManualDrsOrTransitAdjustmentMutationVariables,
  APITypes.SubmitManualDrsOrTransitAdjustmentMutation
>;
export const submitEntryContextUpdate = /* GraphQL */ `mutation SubmitEntryContextUpdate(
  $entryContextUpdates: [EntryContextUpdate!]!
) {
  submitEntryContextUpdate(entryContextUpdates: $entryContextUpdates) {
    status
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitEntryContextUpdateMutationVariables,
  APITypes.SubmitEntryContextUpdateMutation
>;
export const submitCreateInventoryReport = /* GraphQL */ `mutation SubmitCreateInventoryReport($reportType: ReportType) {
  submitCreateInventoryReport(reportType: $reportType) {
    message
    success
    timestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitCreateInventoryReportMutationVariables,
  APITypes.SubmitCreateInventoryReportMutation
>;
